export const headerContent = {
    fr: {
        navLinks: [
            { label: 'Contenu', href: '#films' },
            { label: 'Sport', href: '#sports' },
            { label: 'Appareils', href: '#device' },
            { label: 'Tarifs', href: '#services' },
            { label: 'FAQ', href: '#faq' },
        ],
        callLabel: (phone) => `Appeler le ${phone}`,
        emailLabel: 'Envoyer un email',
        whatsappLabel: 'Contacter sur WhatsApp',
        offersCta: 'Voir les offres',
        openMenu: 'Ouvrir le menu',
        closeMenu: 'Fermer le menu',
        emailShort: 'Email',
        whatsappShort: 'WhatsApp',
    },
    es: {
        navLinks: [
            { label: 'Contenido', href: '#films' },
            { label: 'Deporte', href: '#sports' },
            { label: 'Dispositivos', href: '#device' },
            { label: 'Precios', href: '#services' },
            { label: 'FAQ', href: '#faq' },
        ],
        callLabel: (phone) => `Llamar al ${phone}`,
        emailLabel: 'Enviar un email',
        whatsappLabel: 'Contactar por WhatsApp',
        offersCta: 'Ver las ofertas',
        openMenu: 'Abrir el menú',
        closeMenu: 'Cerrar el menú',
        emailShort: 'Email',
        whatsappShort: 'WhatsApp',
    },
};
